import React, { Fragment, useEffect, useState } from 'react';
import RequiredStatement from '../CreateKybKyc/RequiredStatement';
import KycBioInput from '../KycBioInput';
import { FieldError } from '../VgsInput/field';
import BeneficialOwners, { BeneficialOwnerData } from '../BeneficialOwners';

export default function FormWrapper({
  form,
  askIsOwner,
  onAddressRegionChange,
  onTitleChange,
  onIsOwnerChange,
  onPercentOwnershipChange,
  onValidChange,
  fieldErrors,
  entityName,
  onBeneficialOwnersChange,
}: {
  form: VGSForm<unknown>;
  askIsOwner: boolean;
  onAddressRegionChange: (region: string) => void;
  onTitleChange: (title: string) => void;
  onIsOwnerChange: (isOwner: boolean) => void;
  onPercentOwnershipChange: (percentOwnership: number) => void;
  onValidChange: (isValid: boolean) => void;
  fieldErrors: FieldError[];
  entityName?: string;
  onBeneficialOwnersChange: (
    beneficialOwnersData: BeneficialOwnerData[],
  ) => void;
}): React.JSX.Element {
  const [kycIsValid, setKycIsValid] = useState(false);
  const [beneficialOwnersAreValid, setBeneficialOwnersAreValid] =
    useState(!askIsOwner);

  useEffect(() => {
    onValidChange(kycIsValid && beneficialOwnersAreValid);
  }, [beneficialOwnersAreValid, kycIsValid, onValidChange]);

  return (
    <Fragment>
      <div className='md:flex mb-5'>
        <div className='md:w-full my-2'>
          <h1 className='page-title'>Personal Details</h1>
          <p className='page-text-primary'>
            A controller is required for every fundraiser to ensure we adhere to
            all anti-money laundering laws. Our payment partner will securely
            validate your details.
          </p>
          <RequiredStatement />
        </div>
      </div>
      <KycBioInput
        onAddressRegionChange={onAddressRegionChange}
        onTitleChange={onTitleChange}
        onIsOwnerChange={onIsOwnerChange}
        onPercentOwnershipChange={onPercentOwnershipChange}
        onValidChange={(isValid): void => {
          setKycIsValid(isValid);
        }}
        form={form}
        askIsOwner={askIsOwner}
        askPercentOwnershipOnLoad={false}
        askTitle={true}
        fieldErrors={fieldErrors}
        entityName={entityName}
      />
      <div className='md:flex mb-5'>
        <div className='md:w-full my-2'>
          <div className='page-text-alert'>
            <p>
              As a reminder, your details must match government records. Please
              ensure your name, DOB & Address are a 100% match to your driver’s
              license.
            </p>
          </div>
        </div>
      </div>
      {askIsOwner && (
        <BeneficialOwners
          onValidChange={(isValid): void => {
            setBeneficialOwnersAreValid(isValid);
          }}
          onChange={onBeneficialOwnersChange}
          form={form}
          fieldErrors={fieldErrors}
        />
      )}
    </Fragment>
  );
}
